import { useTailwind } from "tailwind-rn";

import CardText from "./CardText";

export default function Disclaimer() {
  const tailwind = useTailwind();

  return (
    <CardText.Label
      text="Todos los logotipos y marcas son propiedad de sus respectivos propietarios y son usados únicamente para fines identificativos."
      style={tailwind("m-4")}
    />
  );
}
